import React from 'react'
// libs
import styled from 'styled-components'
// constants
import { Modals } from 'constants/modals'
// components
import MenuItemOrigin from '@mui/material/MenuItem'
// hooks
import { useShowModal } from 'hooks/index'
// themes
import { colors } from 'themes/index'
// types
import { IPlan } from 'types/graphql'

const Wrapper = styled('div')`
  padding: 8px 0;
`

const MenuItem = styled(MenuItemOrigin)`
  && {
    color: ${colors.blue500};
    min-height: inherit;
    padding: 4px 12px;
  }
`

interface Props {
  data: IPlan
  closePopup: () => void
  handleDeleteClick: () => void
}

const Menu: React.FC<Props> = ({ data, closePopup, handleDeleteClick }) => {
  const { showModal } = useShowModal({ modalType: Modals.SUB_PLAN_CREATE_MODAL })

  const { planCreateSubPlan, planDeletePlan } = data.currentPermissions

  const handleCreate = () => {
    closePopup()
    showModal({ parentPlan: data })
  }

  const handleDelete = () => {
    closePopup()
    handleDeleteClick()
  }

  return (
    <Wrapper>
      {planCreateSubPlan && <MenuItem onClick={handleCreate}>Create Sub Plan</MenuItem>}
      {planDeletePlan && <MenuItem onClick={handleDelete}>Delete</MenuItem>}
    </Wrapper>
  )
}

export default Menu
